import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { integrationLogRequest } from './services';
export function useIntegrationLogs(filters) {
    const { token, user } = useSelector(state => state.AppReducer);
    return useQuery(['integrationLogs', user?.id, filters], () => integrationLogRequest(token, '', filters), {
        enabled: !!token && user?.role === 'region_admin', keepPreviousData: true, retry: false,
    });
}
export function useIntegrationLog(id) {
    const { token, user } = useSelector(state => state.AppReducer);
    return useQuery(['integrationLog', user?.id, id], () => integrationLogRequest(token, id), {
        enabled: !!id && !!token && user?.role === 'region_admin', retry: false, staleTime: 300000,
    });
}
